// https://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
export var escapeRegex = function escapeRegex(str) {
  return str.replace(/[\\^$.*+?()[\]{}|]/g, '\\$&');
};